import { render, staticRenderFns } from "./IndexYingyou.vue?vue&type=template&id=70782de8&"
import script from "./IndexYingyou.vue?vue&type=script&lang=js&"
export * from "./IndexYingyou.vue?vue&type=script&lang=js&"
import style0 from "./IndexYingyou.vue?vue&type=style&index=0&id=70782de8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports